import { Box, useTheme } from '@mui/material';

import { CaseContent } from './CaseContent';
import CommentEditorModal from '@frontend/features/workflows/components/StepCommentEditor';
import { BackButton } from '@frontend/features/common/components/BackButton';
import { CaseSidebar } from './CaseSidebar';
import { DraftProvider } from '../context/DraftContext';
import { CaseViewModalsDesktop } from './CaseViewModalsDesktop';
import { routes } from '../../../router/routes';

import { useCaseContext } from '../context';

export const CaseViewDesktop = () => {
  const {
    caseData,
    isOrganizationEditOpen,
    isAgentEditOpen,
    isAgencyEditOpen,
    isTeamEditOpen,
    isLinkCaseOpen,
    isCaseNameEditOpen,
    isStepInstructionsModalOpen,
    isClientSelectorModalOpen,
    onCopyCaseNumber,
    onChangeStatus,
    onChangeIAEnabled,
    onChangeStep,
    onChangeWorkflow,
    onChangeAgency,
    onChangeAgent,
    onChangeName,
    onAssignToMe,
    onChangeOrganization,
    onChangeClient,
    onChangeTeam,
    onSaveLegacySaleOrder,
    onSaveLegacyReference,
    onRemoveRelation,
    toggleClientSelector,
    toggleAgentSelector,
    toggleTeamSelector,
    toggleEditCaseName,
    toggleIsLinkCaseOpen,
    toggleOrganizationEdit,
    toggleAgencyEdit,
    handleStepInstructionsVisibility,
  } = useCaseContext();
  const theme = useTheme();
  return (
    <Box
      display="flex"
      gap={8}
      sx={{
        height: 'calc(100vh - 64px)',
        backgroundColor: theme.palette.paper.dark,
      }}
      overflow="hidden"
    >
      <CaseSidebar
        onEditCaseName={toggleEditCaseName}
        onCopyCaseNumber={onCopyCaseNumber}
        onChangeStatus={onChangeStatus}
        onChangeWorkflow={onChangeWorkflow}
        onChangeIAEnabled={onChangeIAEnabled}
        onChangeStep={onChangeStep}
        onStepInstructionsOpen={handleStepInstructionsVisibility(true)}
        onClientSelectorOpen={toggleClientSelector}
        onOrganizationEditOpen={toggleOrganizationEdit}
        onAgencyEditOpen={toggleAgencyEdit}
        onTeamSelectorOpen={toggleTeamSelector}
        onAgentSelectorOpen={toggleAgentSelector}
        onAssignToMe={onAssignToMe}
        onSaveLegacySaleOrder={onSaveLegacySaleOrder}
        onSaveLegacyReference={onSaveLegacyReference}
        onRemoveRelation={onRemoveRelation}
        onLinkCaseOpen={toggleIsLinkCaseOpen}
      />

      <CommentEditorModal
        readMode
        stepName={String(caseData?.stepName)}
        initialContent={caseData?.stepInstructions}
        open={isStepInstructionsModalOpen}
        onClose={handleStepInstructionsVisibility(false)}
      />

      <Box display="flex" flexDirection="column" pt={3} pb={2} pr={8} flex={1} gap={3}>
        <BackButton backRoute={routes.dashboard.cases} />
        <DraftProvider caseId={caseData?.id?.toString() ?? ''}>
          <CaseContent
            clientData={{
              clientEmail: caseData?.clientEmail,
              clientFirstName: caseData?.clientFirstName,
              clientId: caseData?.clientId,
              clientLastName: caseData?.clientLastName,
              clientWhatsappNumber: caseData?.clientWhatsappNumber,
              clientPhoneCountryCode: caseData?.clientPhoneCountryCode,
              clientPhoneNumber: caseData?.clientPhoneNumber,
            }}
          />
        </DraftProvider>
      </Box>

      <CaseViewModalsDesktop
        caseData={caseData}
        caseId={caseData?.id?.toString() ?? ''}
        isLinkCaseOpen={isLinkCaseOpen}
        onCloseLinkCase={toggleIsLinkCaseOpen}
        isOrganizationEditOpen={isOrganizationEditOpen}
        onCloseOrganizationEdit={toggleOrganizationEdit}
        onSelectOrganization={onChangeOrganization}
        isAgencyEditOpen={isAgencyEditOpen}
        onCloseAgencyEdit={toggleAgencyEdit}
        onSelectAgency={onChangeAgency}
        isClientSelectorModalOpen={isClientSelectorModalOpen}
        onCloseClientSelector={toggleClientSelector}
        onSelectClient={onChangeClient}
        isAgentEditOpen={isAgentEditOpen}
        onCloseAgentSelector={toggleAgentSelector}
        onSelectAgent={onChangeAgent}
        isTeamEditOpen={isTeamEditOpen}
        onCloseTeamSelector={toggleTeamSelector}
        onSelectTeam={onChangeTeam}
        isCaseNameEditOpen={isCaseNameEditOpen}
        onCloseEditCaseName={toggleEditCaseName}
        onSaveCaseName={onChangeName}
      />
    </Box>
  );
};
